<template>
    <span>
        <template v-if="value">
            <span class="flex-1" v-text="value.currency"></span>
            <span :style="valueStyle" v-text="formatted"></span>
        </template>
        <slot v-else>
            <span class="flex-1"></span>
            <span>-</span>
        </slot>
    </span>
</template>

<script type="text/babel">
export default {
    props: {
        value: {},
        decimals: {
            type: Number,
            default: 0,
        },
        valueStyle: {
            type: String,
            default: '',
        },
    },

    computed: {
        formatted() {
            return this.formatMoney(this.$get(this.value, 'amount'))
        },
    },

    methods: {
        formatMoney(amount) {
            if (amount === '' || isNaN(amount)) {
                amount = 0
            }

            let w = amount.toFixed(this.decimals),
                k = Math.floor(amount),
                b = amount < 0 ? 1 : 0,
                u = Math.abs(w - k),
                d = ('' + u.toFixed(this.decimals)).substr(2, this.decimals),
                s = '' + k,
                i = s.length,
                r = ''
            while ((i -= 3) > b) {
                r = '.' + s.substr(i, 3) + r
            }
            return s.substr(0, i + 3) + r + (d ? ',' + d : '')
        },
    },
}
</script>
